export default defineNuxtRouteMiddleware(async (to) => {
  const { $store, $keycloak, $apis, $config } = useNuxtApp()

  // This is the successful authentication handler
  if ($keycloak.authenticated) {
    // Setting up the subdomain
    const { host } = new URL(location.href)
    let subdomainPrefix = ''
    if (host !== $config.public.fullyQualifiedDomain) {
      const subDomain = host.split('.')[0]
      // Check if the subdomain is www
      subdomainPrefix = (subDomain === 'www') ? '' : subDomain
      $store.companies.setSubdomain(subdomainPrefix)
    }

    // Setting up the user data
    try {
      const userData = await $apis.auth.fetchUser()
      $store.auth.setUser(userData.data)

      const userAccountDetails = await $apis.accounts.fetchUserDetails()
      $store.userSettings.setUserRoles(userAccountDetails.data.roles)

      const companyData = await $apis.companies.fetchAll()
      if (companyData.data.length) {
        $store.companies.setCompanies(companyData.data)
      }
    }
    catch (error) {
      // Error in fetching user data means something is terribly wrong
      // Log the user out and redirect to landing page
      console.error('Error fetching user data', error)
      $store.auth.logout()
      return navigateTo('/')
    }

    const { is_superuser, is_zuno_engineer, is_super_typewriter } = $store.auth.authenticatedUser
    const isAdmin = is_zuno_engineer || is_super_typewriter

    if (is_superuser) {
      return navigateTo('/superadmin/home')
    }

    if (isAdmin) {
      return navigateTo('/admin/home')
    }

    // Case: User's company has not been created yet
    if ($store.companies.companies.length === 0 && !isAdmin) {
      return navigateTo('/company/create')
    }

    // Case: Redirect URL is provided
    const redirectPath = to.query.redirect as string
    if (redirectPath) {
      return navigateTo(redirectPath)
    }

    // Case: Default redirect to home
    return navigateTo('/dashboard/home')
  }
})
